const Vendors = () => import("Core/companies/vendors/views/Vendors");
const VendorsForm = () => import("Core/companies/vendors/views/VendorsForm");
const VendorProfile = () => import("Core/companies/vendors/views/VendorProfile");

export default {
    children: [
        {
            path: "configuration/vendors",
            name: "vendors",
            component: Vendors,
            meta: {
                requiresAuth: true,
                title: "lang.vendors",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "configuration/vendor/:id?",
            name: "vendor",
            component: VendorProfile,
            meta: {
                requiresAuth: true,
                title: "lang.vendors",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
